import { useTranslation } from 'react-i18next';
import { MyLink } from '@scramble/ui';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

export const PublicFooter = () => {
  const { t } = useTranslation('footer');
  return (
    <footer className={s.footer}>
      <div className="g-container">
        <div className={s.copyright}>
          {t('scramble_ou_all_rights_reserved', {
            year: new Date().getFullYear(),
          })}
        </div>
        <div className={s.links}>
          <MyLink href={APP_LINKS.termOfUse} isExternal newWindow>
            Terms of Service
          </MyLink>
          <span className="f-body-sm f-400">&</span>
          <MyLink href={APP_LINKS.privacyPolicy} isExternal newWindow>
            Privacy Policy
          </MyLink>
        </div>
      </div>
    </footer>
  );
};